/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import React from 'react';
import OnDemandGrid from './Grid';
import MainPage from './MainPage';
import NextLevel from './NextLevel';

interface Props {
  onNextLevel?: boolean;
  onGridMode?: boolean;
}

export default function OnDemand({ onNextLevel, onGridMode }: Props): JSX.Element {
  if (onNextLevel) {
    return <NextLevel />;
  }

  if (onGridMode) {
    return <OnDemandGrid />;
  }

  return <MainPage />;
}
